module.exports = __webpack_public_path__ + "img/male.fd4f4325.svg";